import { createFileRoute, notFound, redirect } from "@tanstack/react-router"

import { cleanEmptyParams } from "@/utilities/etc"

export const Route = createFileRoute("/receipt/")({
  validateSearch: (
    search: Record<string, unknown>
  ): {
    receiptID?: string
  } => {
    return cleanEmptyParams({
      receiptID: (search.receiptID as string) || "",
    })
  },
  beforeLoad: ({ search }) => {
    if (search.receiptID)
      throw redirect({
        to: "/receipt/$receiptID",
        params: { receiptID: search.receiptID },
      })
    throw notFound()
  },
  component: undefined,
})
